export const SET_ALL_ROLES = 'SET_ALL_ROLES';
export const SET_ALL_FUNCTIONS = 'SET_ALL_FUNCTIONS';
export const SET_ROLE = 'SET_ROLE';
export const SET_USER_FUNCTIONS = 'SET_USER_FUNCTIONS';
export const SET_USER_HOME = 'SET_USER_HOME';
